import React, { useState, useEffect } from "react";
import "./MantrasList.css";

const AddMantraForm = ({ categoryId, categoryName, onClose, onMantraAdded }) => {
  const [formData, setFormData] = useState({ title: "", mantra_text: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title.trim() || !formData.mantra_text.trim()) {
      setError("Both title and mantra text are required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await fetch(
        `https://pooja-path-1.onrender.com/api/mantras/categories/${categoryId}/mantras/add/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: formData.title.trim(),
            mantra_text: formData.mantra_text.trim(),
          }),
        }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to add mantra");

      onMantraAdded();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content mantras-form-modal">
        <div className="modal-header">
          <h3>Add Mantra to "{categoryName}"</h3>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <form className="add-form" onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="title">Mantra Title *</label>
            <input
              id="title"
              name="title"
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              className="form-input"
              placeholder="Enter mantra title"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="mantra_text">Mantra Text *</label>
            <textarea
              id="mantra_text"
              name="mantra_text"
              value={formData.mantra_text}
              onChange={(e) =>
                setFormData({ ...formData, mantra_text: e.target.value })
              }
              className="form-textarea"
              rows={12}
              placeholder="Enter the complete mantra text..."
              required
            />
            <div className="character-count">{formData.mantra_text.length} characters</div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? "… Adding..." : "➕ Add Mantra"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddMantraForm;
